import { render, staticRenderFns } from "./UnBindTable.vue?vue&type=template&id=1aba0d16&scoped=true&"
import script from "./UnBindTable.vue?vue&type=script&lang=js&"
export * from "./UnBindTable.vue?vue&type=script&lang=js&"
import style0 from "./UnBindTable.vue?vue&type=style&index=0&id=1aba0d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba0d16",
  null
  
)

export default component.exports